import React from "react";
import AppHeader from "src/components/headers/AppHeader";
import AllianceSection from "src/containers/sections/AllianceSection";
import FooterSection from "src/containers/sections/FooterSection";
import GetStartedSection from "src/containers/sections/GetStartedSection";
import HowItsWorkSection from "src/containers/sections/HowItsWorkSection";
import PartnersSection from "src/containers/sections/PartnersSection";
import RecapSection from "src/containers/sections/RecapSection";
import ServicesSection from "src/containers/sections/ServicesSection";

const Home = () => {
  return (
    <div className="text-white">
      <div className="px-2 py-2 bg-gradient-to-r from-[#05132D] to-[#00273C]">
        <AppHeader />
        <GetStartedSection />
      </div>
      <AllianceSection />
      <PartnersSection />
      <HowItsWorkSection />
      <ServicesSection />
      <RecapSection />
      <FooterSection />
    </div>
  );
};

export default Home;
